
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 sm:pt-24 pb-12 sm:pb-16">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/2426b33c0f3a33c1c1d632ef6612f33e.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight font-['Playfair_Display']">
            Collision Experts
          </h1>

          <div className="inline-flex items-center gap-2 bg-orange-600/90 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full mb-6 sm:mb-8">
            <i className="ri-star-fill text-yellow-300 text-lg sm:text-xl"></i>
            <span className="text-sm sm:text-base font-semibold whitespace-nowrap">30+ Years of Excellence in Brooklyn</span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight font-['Playfair_Display']">
            Trusted Collision Experts<br />
            <strong className="text-orange-400">in Brooklyn, NY</strong>
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-8 sm:mb-10 leading-relaxed px-4">
            Expert collision repair, auto body painting, dent removal, and frame straightening. We work with all insurance companies to get you back on the road quickly.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 sm:mb-10 px-4">
            <a
              href="tel:+16319337887"
              className="w-full sm:w-auto bg-orange-600 hover:bg-orange-700 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-lg sm:text-xl font-bold transition-all hover:scale-105 shadow-2xl whitespace-nowrap text-center"
            >
              <i className="ri-phone-fill mr-2"></i>
              Call: (631) 933-7887
            </a>
            <Link
              to="/contact"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-white text-gray-900 hover:bg-gray-100 px-8 sm:px-10 py-4 sm:py-5 rounded-full text-lg sm:text-xl font-bold transition-all hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              Get a Free Estimate
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>

          <div className="inline-flex flex-wrap items-center justify-center gap-4 sm:gap-6 bg-black/50 backdrop-blur-sm px-4 sm:px-8 py-4 sm:py-5 rounded-2xl mx-4">
            <div className="flex items-center gap-2 text-white">
              <i className="ri-shield-check-fill text-xl sm:text-2xl text-orange-400"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">30+ Years Experience</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <i className="ri-file-list-3-fill text-xl sm:text-2xl text-orange-400"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">All Insurance Accepted</span>
            </div>
            <div className="flex items-center gap-2 text-white">
              <i className="ri-time-fill text-xl sm:text-2xl text-orange-400"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Same-Day Service</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden sm:block">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
};

export default HeroSection;
